import { render, staticRenderFns } from "./brush-teeth.vue?vue&type=template&id=f90bf19e&"
import script from "./brush-teeth.vue?vue&type=script&lang=js&"
export * from "./brush-teeth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports